import { PaginaPesquisaProdutoContainer } from "./PaginaPesquisaProdutoContainer"
import React from "react"

declare var window: any

export const PesquisaProdutoForaOrcamento = () => {
    return (
        <>
            <PaginaPesquisaProdutoContainer
                pesquisandoApenasParaFiltroProdutosLupa={false}
                chamadoParaInserirProdutoNoOrcamento={false}
                chamadoPeloTrocarProduto={false}
                foraOrcamento={true}
                esconderForaEstoque
                regiaoRenderizada="pesquisa-produtos-region" />
        </>
    )
}

window.PesquisaProdutoForaOrcamento = PesquisaProdutoForaOrcamento